import exchangesRateCoin from '../widgets/exchangesRateCoin.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await exchangesRateCoin.updateDynamicsData();
    });
}(jQuery));